var map = {
	"./chargingpoint-alert.png": "3910",
	"./chargingpoint-definitive.png": "dc99",
	"./chargingpoint-fastcharger-planned.png": "42df",
	"./chargingpoint-fastcharger-realized.png": "202f",
	"./chargingpoint-fastcharger-rejected.png": "2028",
	"./chargingpoint-in-progress.png": "d86f",
	"./chargingpoint-realized-private.png": "c950",
	"./chargingpoint-realized.png": "2712",
	"./chargingpoint-rejected.png": "320a",
	"./chargingpoint-suggestion.png": "107b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70bb";